import { hasDuplicateItems } from '../../../core/utils/array';
import { QueryExecutionResponse, QueryExecutionStatusEnum } from '../interfaces/workbench';

const FIELD_SEPARATOR = ',';

/**
 * @returns string to create the CSV file after processing
 *
 * @param queryOutput - query output result with header data
 */
export function getQueryResultCSV(queryOutput) {
  let csvString = '';

  const headerRow = queryOutput.headers.map((header) => createFieldStringifier(header.name));
  csvString = headerRow.join(FIELD_SEPARATOR) + '\n';

  try {
    queryOutput.rows.map((row) => {
      const formattedRow = [];

      row.forEach((cell) => {
        let formattedCell = cell;

        if (cell?.json) {
          formattedCell = JSON.stringify(JSON.parse(cell.json));

        } else if (Array.isArray(cell)) {
          formattedCell = cell.join(',');
        }

        if (typeof formattedCell === 'string') {
          formattedCell = createFieldStringifier(formattedCell);
        }

        formattedRow.push(formattedCell);
      });

      csvString = csvString + formattedRow.join(FIELD_SEPARATOR) + '\n';
    });
  } catch (e) {
    console.error(e);
  }

  return csvString;
}

/**
 * Returns the stringified version of the field cell
 *
 * @param fieldCell - field cell to stringify
 */
function createFieldStringifier(fieldCell: any) {
  return isEmpty(fieldCell) ? '' : quoteField(fieldCell);
}

function isEmpty(value?: any): boolean {
  return typeof value === 'undefined' || value === null || value === '';
}

function quoteField(field: string): string {
  return `"${ field.replace(/"/g, '""') }"`;
}

export function checkResponseForDuplicateColumns(queryExecutionResponse) {
  if (!queryExecutionResponse?.data?.output?.headers) {
    return false;
  }

  const headerNames = queryExecutionResponse.data.output.headers.map((header: any) => header.name);

  return hasDuplicateItems(headerNames);
}

export function getQueryExecutionResponseFromRawData(data: any): QueryExecutionResponse {
  const result = data.result;
  const status = data.status;

  switch (status) {
    case 'SUCCESS': {
      return {
        data: {
          output: result.data,
          runTime: result.runtime,
          hasMoreResults: result.hasMoreResults
        },
        status: QueryExecutionStatusEnum.SUCCESS
      };
    }
    case 'FAILED': {
      return {
        error: result.error,
        status: QueryExecutionStatusEnum.FAILED
      };
    }
    case 'CANCELLED': {
      return {
        data: null,
        status: QueryExecutionStatusEnum.FAILED
      };
    }
    case 'QUEUED': {
      return {
        data: null,
        status: QueryExecutionStatusEnum.QUEUED
      };
    }
    case 'RUNNING': {
      return {
        data: null,
        status: QueryExecutionStatusEnum.RUNNING
      };
    }
    case 'CANCEL_REQUESTED': {
      return {
        data: null,
        status: QueryExecutionStatusEnum.CANCEL_REQUESTED
      };
    }
  }
}
